import {atom} from "jotai";

/**
 * 광고비 잔액
 */
export const retrieveUserPoint = atom(0)

/**
 * 결제 추가한 광고비
 */
export const requestAmountPoint = atom(0)